<template>
  <div ref="editor"></div>
</template>

<script>
import Quill from 'quill';

export default {
  props: {
    value: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      editor: null,
    };
  },
  watch: {
    value(newValue) {
      if (newValue !== this.editor.root.innerHTML) {
        const delta = this.editor.clipboard.convert(newValue);
        this.editor.setContents(delta);
      }
    },
    disabled(status) {
      this.editor.enable(!status);
    },
  },
  mounted() {
    this.editor = new Quill(this.$refs.editor, {
      modules: {
        toolbar: [
          [{ header: [1, 2, false] }],
          ['bold', 'italic', 'underline'],
          [{ list: 'ordered' }, { list: 'bullet' }],
        ],
      },
      theme: 'snow',
      formats: ['bold', 'italic', 'underline', 'list', 'header'],
    });

    const delta = this.editor.clipboard.convert(this.value);
    this.editor.setContents(delta);

    this.editor.on('text-change', () => {
      this.update();
    });
  },
  beforeDestroy() {
    this.editor = null;
    delete this.quill;
  },
  methods: {
    update() {
      this.$emit('input', this.editor.root.innerHTML);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../node_modules/quill/dist/quill.snow.css';
@import '@/assets/scss/_mixins';

.ql-container {
  height: 340px;
  @include orange-scrollbar;
  margin-bottom: 20px;
}
</style>
